import React from "react";
import CardLayout from "../../../../common/cardLayout/CardLayout";
import PatientNotesTable from "./PatientNotesTable";
import PatientLoader from "../../../../common/PatientLoader";
import { NoAssessments } from "../FlaggedJournals";
import { useSelector } from "react-redux";
import moment from "moment";
import { getFullName } from "../../../../../util/helpers";

export const PatientNotesPDFComponent = ({ showTitle = true }) => {
  const { patientNotes, patientNotesLoading } = useSelector(
    (state) => state.patient
  );
  const { staffData } = useSelector((state) => state.app);

  const getManagedBy = (id) => {
    const added_by_staff = staffData?.find((staff) => {
      if (staff?.id === id) {
        return staff;
      }
    });
    return getFullName(added_by_staff) || "Not available";
  };

  return (
    <CardLayout
      className="container-fluid"
      style={{ margin: "0px", padding: "0px" }}
    >
      {showTitle && (
        <div className="container-fluid d-flex">
          <label style={{ fontSize: "1.3rem" }}>Patient Notes</label>
        </div>
      )}

      {patientNotesLoading ? (
        <PatientLoader />
      ) : (
        <table className="table px-2">
          <thead className="thead-light" style={{ backgroundColor: "#F9FAFB" }}>
            <tr
              style={{
                height: "4rem",
                verticalAlign: "middle",
              }}
            >
              <th scope="col">
                <span className="muted-text">Date Taken</span>
              </th>
              <th scope="col">
                <span className="muted-text">Creator</span>
              </th>
              <th scope="col">
                <span className="muted-text">BH Diagnosis</span>
              </th>
              <th scope="col">
                <span className="muted-text">Note</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {patientNotes?.map((notes) => {
              return (
                <tr
                  key={notes?.id}
                  className="py-3"
                  style={{
                    height: "4rem",
                    verticalAlign: "middle",
                  }}
                >
                  <td>
                    <small style={{ fontWeight: "500" }}>
                      {moment(notes?.created).format("MMM DD, YYYY") ||
                        "Not Available"}
                    </small>
                  </td>
                  <td>
                    <small style={{ fontWeight: "500" }}>
                      {getManagedBy(notes?.added_by) || "-"}
                    </small>
                  </td>
                  <td>
                    <small style={{ fontWeight: "500" }}>
                      {notes?.diagnosis || "-"}
                    </small>
                  </td>
                  <td>
                    <small style={{ fontWeight: "500" }}>
                      {notes?.notes || "-"}
                    </small>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </CardLayout>
  );
};

const PatientNotes = (props) => {
  const { patientNotes, patientNotesLoading } = useSelector(
    (state) => state.patient
  );
  const patientNoteData = patientNotes?.filter(note => note.activity === null || note.activity === '');
  return (
    <CardLayout
      className="col-sm-12 col-md-12 col-lg-12"
      style={{
        border: "8px solid transparent",
        boxSizing: "border-box",
        backgroundClip: "padding-box",
      }}
    >
      <div className="container-fluid p-4">
        {props?.showTitle && (
          <div className="d-flex mb-4 mt-2">
            <label style={{ fontSize: "1.3rem" }}>All Notes</label>
          </div>
        )}

        <div className="container-fluid">
          {patientNotesLoading ? (
            <PatientLoader />
          ) : (
            <>
              {patientNoteData.length === 0 ? (
                <NoAssessments
                  text="No notes for this patient!"
                  show_link={false}
                />
              ) : (
                <PatientNotesTable
                  startDate={props?.startDate}
                  endDate={props?.endDate}
                  data={patientNoteData}
                  notesFilterValue={props?.notesFilterValue}
                  notesDownloadMode={props?.notesDownloadMode}
                  setNotesDownloadMode={props?.setNotesDownloadMode}
                />
              )}
            </>
          )}
        </div>
      </div>
    </CardLayout>
  );
};
export default PatientNotes;
